// extracted by mini-css-extract-plugin
module.exports = {"documentHeader":"DownloadButton_documentHeader__2QL4S"};